import React from 'react';

class Standalone extends React.Component {
    componentDidMount() {
        this.connect();
    };

    connect() {
        this.socket = new WebSocket(this.props.url);
        this.socket.binaryType = 'arraybuffer';

        this.socket.onopen = () => {
            this.receiveQuotes(this.props.code);
        };

        this.socket.onclose = () => {
            this.connect();
        };

        this.socket.onmessage = (msg) => {
            let data = msg.data;

            if (data instanceof ArrayBuffer) {
                data = String.fromCharCode.apply(null, new Uint8Array(data));
            }

            data = JSON.parse(data);

            this.props.callback(data);
        }
    }

    receiveQuotes(code) {
        this.socket.send(JSON.stringify([
            {"type": "trade", "codes": [code], "gBoard": "REGULAR_HOURS", "isOnlyRealtime": true},
            {"ticket": "web-chart-react"}
        ]));
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.code !== this.props.code) {
            this.receiveQuotes(this.props.code);
        }
    };

    render() {
        return this.props.children;
    };
};

export default Standalone;